import {BsModalRef} from "ngx-bootstrap/modal";
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import {EventEmitter} from "@angular/core";
import {Observable, of} from "rxjs";

export abstract class AbstractModalComponent {
  public event: EventEmitter<any> = new EventEmitter();
  messages = [];
  formDirty = false;

  constructor(public _bsModalRef: BsModalRef,
              public modal: WarningModalService) {
  }

  setMessages(newMessages) {
    this.messages = this.messages.concat(newMessages);
  }

  isDirty(): boolean {
    return this.formDirty || this.getForm().dirty;
  }

  markAsPristine() {
    this.getForm().form.markAsPristine();
    this.formDirty = false;
  }

  canDeactivate(): Observable<boolean> {
    // If component is dirty, warn user
    if (this.isDirty()) {
      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton, true);
    } else {
      return of(true);
    }
  }

  abstract getForm();
}
